var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[(_vm.screenWidth < 765)?_c('downloadPageMb',{staticClass:"is-mb"}):_c('downloadPagePc',{staticClass:"is-pc"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }